var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_20_1126)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35 0C15.7013 0 0 15.7013 0 35C0 54.2987 15.7013 70 35 70C54.2987 70 70 54.2987 70 35C70 15.7013 54.2987 0 35 0ZM35 67.0833C17.3092 67.0833 2.91667 52.6908 2.91667 35C2.91667 17.3092 17.3092 2.91667 35 2.91667C52.6908 2.91667 67.0833 17.3092 67.0833 35C67.0833 52.6908 52.6908 67.0833 35 67.0833Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.28541 23.3333C6.71724 26.9097 5.83337 30.8514 5.83337 34.9999C5.83337 46.8095 12.9009 56.9796 23.0174 61.5622L9.55736 23.3333H8.28541Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.3334 21.8749C23.3334 22.681 22.6811 23.3333 21.8751 23.3333H21.0337L29.2109 48.7003C30.7012 44.4504 32.2347 40.0339 33.4248 36.5072L28.7863 23.3333H27.7084C26.9023 23.3333 26.2501 22.681 26.2501 21.8749C26.2501 21.0688 26.9023 20.4166 27.7084 20.4166H40.8334C41.6395 20.4166 42.2917 21.0688 42.2917 21.8749C42.2917 22.681 41.6395 23.3333 40.8334 23.3333H40.2627L48.4398 48.7003C50.1345 43.8695 51.8962 38.7924 53.1295 35.0896C53.6892 32.2912 51.5174 28.7749 49.5891 25.6546C48.0895 23.2264 46.7935 21.1287 46.7935 19.3385C46.7935 13.8769 49.9722 13.0608 51.8663 13.0608C53.0081 13.0608 54.0524 13.3663 55.0119 13.8377C49.7833 8.89073 42.7492 5.83325 35.0001 5.83325C24.2322 5.83325 14.8319 11.7134 9.77954 20.4166H21.8751C22.6811 20.4166 23.3334 21.0688 23.3334 21.8749Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.2168 63.0802C29.6989 63.7693 32.3014 64.1666 35 64.1666C37.6979 64.1666 40.2994 63.7695 42.7808 63.0807L34.9907 40.9551C32.2047 49.0662 28.4992 59.4844 27.2168 63.0802Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.6915 18.0525C59.8837 21.7829 58.4209 28.1327 56.8707 33.0303C56.6186 33.8293 56.3053 34.7863 55.9479 35.8615C55.9137 36.0082 55.8752 36.1549 55.8311 36.3016C55.7983 36.4141 55.7513 36.5209 55.6944 36.6192C53.2103 44.0267 48.9239 56.1212 46.9878 61.5597C57.1016 56.9759 64.1666 46.8076 64.1666 34.9999C64.1666 28.6774 62.1228 22.8353 58.6915 18.0525Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35 0C15.7013 0 0 15.7013 0 35C0 54.2987 15.7013 70 35 70C54.2987 70 70 54.2987 70 35C70 15.7013 54.2987 0 35 0Z",
    fill: "url(#paint0_linear_20_1126)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_20_1126",
    x1: 3.28101,
    y1: 20.2092,
    x2: 66.719,
    y2: 49.7908,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_20_1126"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 70,
    height: 70,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWp);
export default __webpack_public_path__ + "static/media/wp.5898dad9938b623db041521658155c05.svg";
export { ForwardRef as ReactComponent };